// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { IExternalTemplateLiteDto } from './IExternalTemplateLiteDto';
import {
    IExternalTemplateLiteDtoFromJSON,
    IExternalTemplateLiteDtoFromJSONTyped,
    IExternalTemplateLiteDtoToJSON,
    IExternalTemplateLiteDtoToJSONTyped,
} from './IExternalTemplateLiteDto';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageExternalTemplateLiteDto
 */
export interface IPageExternalTemplateLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IPageExternalTemplateLiteDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageExternalTemplateLiteDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageExternalTemplateLiteDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IExternalTemplateLiteDto>}
     * @memberof IPageExternalTemplateLiteDto
     */
    content?: Array<IExternalTemplateLiteDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageExternalTemplateLiteDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageExternalTemplateLiteDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageExternalTemplateLiteDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageExternalTemplateLiteDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageExternalTemplateLiteDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageExternalTemplateLiteDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageExternalTemplateLiteDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageExternalTemplateLiteDto interface.
 */
export function instanceOfIPageExternalTemplateLiteDto(value: object): value is IPageExternalTemplateLiteDto {
    return true;
}

export function IPageExternalTemplateLiteDtoFromJSON(json: any): IPageExternalTemplateLiteDto {
    return IPageExternalTemplateLiteDtoFromJSONTyped(json, false);
}

export function IPageExternalTemplateLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageExternalTemplateLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IExternalTemplateLiteDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageExternalTemplateLiteDtoToJSON(json: any): IPageExternalTemplateLiteDto {
    return IPageExternalTemplateLiteDtoToJSONTyped(json, false);
}

export function IPageExternalTemplateLiteDtoToJSONTyped(value?: IPageExternalTemplateLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IExternalTemplateLiteDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

